import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'signin',
    loadComponent: () => import('./sign-in/sign-in.component'),
  },
  {
    path: 'signup',
    loadComponent: () => import('./sign-up/sign-up.component'),
  },
  {
    path: 'signout',
    loadComponent: () => import('./sign-out/sign-out.component'),
  },
  {
    path: 'legal/:type',
    loadComponent: () => import('./legal/legal-document.component'),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.component'),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.component'),
  },
  {
    path: 'accept-invitation-premium',
    loadComponent: () => import('./accept-invitation-premium/accept-invitation-premium.component'),
  },
  {
    path: 'accept-invitation-custom',
    loadComponent: () => import('./accept-invitation-custom/accept-invitation-custom.component'),
  },
  {
    path: 'password-recovery',
    loadComponent: () => import('./password-recovery/password-recovery.component'),
  },
  {
    path: 'payment-success',
    loadComponent: () => import('./payment-success/payment-success.component'),
  },
  {
    path: 'email-check',
    loadComponent: () => import('./mail-check/mail-check.component'),
  },
  {
    path: 'account-ready',
    loadComponent: () => import('./account-ready/account-ready.component'),
  },
  {
    path: 'invitation-login',
    loadComponent: () => import('./invitation-login/invitation-login.component'),
  },
  {
    path: 'change-password',
    loadComponent: () => import('./change-password/change-password.component'),
  },

  {
    path: 'change-email',
    loadComponent: () => import('./change-email/change-email.component'),
  },

  {
    path: 'confirm-change-email',
    loadComponent: () => import('./confirm-change-email/confirm-change-email.component'),
  },

  {
    path: 'mail-change-check',
    loadComponent: () => import('./mail-change-check/mail-change-check.component'),
  },
  {
    path: 'validate-email-token',
    loadComponent: () => import('./validate-email-token/validate-email-token.component'),
  },
  {
    path: 'email-confirmed',
    loadComponent: () => import('./email-confirmed/email-confirmed.component'),
  },

  {
    path: 'password-confirmed',
    loadComponent: () => import('./password-confirmed/password-confirmed.component'),
  },
  {
    path: 'create-account-check-email',
    loadComponent: () => import('./create-account-check-email/create-account-check-email.component'),
  },
  {
    path: 'invitation-error',
    loadComponent: () => import('./invitation-error/invitation-error.component'),
  },
  {
    path: 'confirm-email',
    loadComponent: () => import('./confirm-email/confirm-email.component'),
  },
  {
    path: 'accepted-email',
    loadComponent: () => import('./accepted-email/accepted-email.component'),
  },
  {
    path: 'invitation-email-confirmation',
    loadComponent: () => import('./invitation-email-confirmation/invitation-email-confirmation.component'),
  },
  {
    path: 'accept-invitation-coach',
    loadComponent: () => import('./accept-invitation-coach/accept-invitation-coach.component'),
  },

  {
    path: 'accept-invitation-organization-admin',
    loadComponent: () =>
      import('./accept-invitation-organization-admin/accept-invitation-organization-admin.component'),
  },

  {
    path: 'accept-invitation-super-admin',
    loadComponent: () =>
      import('./accept-invitation-organization-admin/accept-invitation-organization-admin.component'),
  },

  {
    path: 'confirm-email-coach',
    loadComponent: () => import('./confirm-email-coach/confirm-email-coach.component'),
  },
  {
    path: 'confirm-email-organization-admin',
    loadComponent: () => import('./confirm-email-coach/confirm-email-coach.component'),
  },
  {
    path: 'confirm-email-super-admin',
    loadComponent: () => import('./confirm-email-coach/confirm-email-coach.component'),
  },
];
